"use strict";
import Hashcash from "src/vendor/hashcash";
Hashcash.setup();
